import { renderMaskedField } from "@/shared/components/form/FormField";
import { SelectField } from "@/shared/components/form/Select";
import images from "@/shared/img/uploader/placeholder.png";
import { useMutation, useQuery } from "@apollo/client";
import { css } from "@emotion/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import MoonLoader from "react-spinners/MoonLoader";
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from "reactstrap";
import {
  UPDATE_USER,
  UPDATE_USER_ADDITIONAL_INFO,
} from "../../GraphQL/Mutation";
import DatePicker from "react-datepicker";
import {
  LOAD_DISTRICT,
  LOAD_DIVISION,
  LOAD_UNION,
  LOAD_UPAZILLA,
} from "../../GraphQL/Queries";
import BASE_URL from "../../utils/api/baseUrl";
import { FormField } from "./FormField";
import imageUrl from "@/utils/api/imageUrl";
import { bloodGroupOption } from "@/utils/dropdown";
import moment from "moment";

const AgentProfileUpdate = ({ isHorizontal, isAboveError }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  // retrive data from local storage
  const userData = history?.location?.state?.user;
  console.log("🚀 ~ AgentProfileUpdate ~ userData:", userData);
  const userID = history?.location?.state?.id;
  const farmer = history.location?.state?.farmers;
  const [birthDate, setBirthDate] = useState(new Date());
  const getDivision = JSON.parse(localStorage?.getItem("division"))?.find(
    (data) => data?.id == userData?.division
  );
  const getDistrict = JSON.parse(localStorage?.getItem("district"))
    ?.filter((data) => data?.division_id == userData?.division)
    ?.find((data) => data?.id == userData?.district);

  const getUpazilla = JSON.parse(localStorage?.getItem("upazilla"))
    ?.filter((data) => data?.district_id == userData?.district)
    ?.find((data) => data?.id == userData?.upazilla);

  const getUnion = JSON.parse(localStorage?.getItem("union"))
    ?.filter((data) => data?.upazilla_id == userData?.upazilla)
    ?.find((data) => data?.id == userData?.union);

  const [preview, setPreview] = useState("");
  const [image, setImage] = useState(userData?.images);
  const [division, setDivision] = useState([]);
  const [district, setDistrict] = useState([]);
  const [upazilla, setUpazilla] = useState([]);
  const [union, setUnion] = useState([]);

  useEffect(() => {
    if (userData?.additionalInfo?.date_of_birth) {
      const joiningDateStr = userData.additionalInfo.date_of_birth;
      const parsedDate = Date.parse(joiningDateStr);

      if (!isNaN(parsedDate)) {
        setBirthDate(new Date(parsedDate));
      }
    }
  }, [userData]);
  const handleBirtDateChange = (date) => {
    const today = new Date();
    if (!date || isNaN(date.getTime())) {
      alert("Invalid date value. Please select a valid date.");
      setBirthDate(null);
    } else if (date > today) {
      alert("Future dates are not allowed.");
      setBirthDate(null);
    } else {
      setBirthDate(date);
    }
  };
  // update mutatiion
  const [updateUser, updateUserStatus] = useMutation(UPDATE_USER);
  const [updateUserAdditionalInfo, updateUserAdditionalInfoFeedback] =
    useMutation(UPDATE_USER_ADDITIONAL_INFO);
  let defaultDivision = JSON.parse(localStorage?.getItem("division"))?.find(
    (division) => division?.id == farmer?.division
  );
  let defaultDistrict = JSON.parse(localStorage?.getItem("district"))?.find(
    (district) =>
      district?.id == farmer?.district &&
      defaultDivision?.id == district?.division_id
  );

  let defaultUpazilla = JSON.parse(localStorage?.getItem("upazilla"))?.find(
    (upazilla) => upazilla?.id == farmer?.upazilla
  );
  let defaultUnion = JSON.parse(localStorage?.getItem("union"))?.find(
    (union) => union?.id == farmer?.union
  );

  const {
    handleSubmit,
    watch,
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { nid: userData?.additionalInfo?.nid },
    defaultValues: { e_tin: userData?.additionalInfo?.e_tin },
  });
  const nidValue = watch("nid") || "";
  const maxDigits = 20;
  const eTinValue = watch("e_tin") || "";
  //   address field
  const divisionQuery = useQuery(LOAD_DIVISION);
  const districtQuery = useQuery(LOAD_DISTRICT, {
    variables: {
      division_id: Number(watch("division")?.value),
    },
  });
  const upazillaQuery = useQuery(LOAD_UPAZILLA, {
    variables: {
      district_id: Number(watch("district")?.value),
    },
  });

  const unionQuery = useQuery(LOAD_UNION, {
    variables: {
      upazilla_id: Number(watch("upazilla")?.value),
    },
  });

  const divisionId = watch("division")?.value;
  const districtId = watch("district")?.value;
  const upazillaId = watch("upazilla")?.value;
  useEffect(() => {
    if (divisionQuery.data?.getDivision?.length > 0) {
      setDivision(divisionQuery?.data?.getDivision);
    }
  }, [divisionQuery?.data?.getDivision?.length]);

  useEffect(() => {
    if (districtQuery?.data?.getDistrictById?.length > 0) {
      setDistrict(districtQuery?.data?.getDistrictById);
    }
  }, [divisionId, districtQuery?.data?.getDistrictById]);

  useEffect(() => {
    if (upazillaQuery.data?.getUpazillaById?.length > 0) {
      setUpazilla(upazillaQuery?.data?.getUpazillaById);
    }
  }, [districtId, upazillaQuery?.data?.getUpazillaById]);
  useEffect(() => {
    if (unionQuery.data?.getUnionById?.length > 0) {
      setUnion(unionQuery?.data?.getUnionById);
    }
  }, [upazillaId, unionQuery?.data?.getUnionById]);

  // final submit form
  const onSubmit = async (data) => {
    console.log("🚀 ~ onSubmit ~ data:", data);
    let isFile;
    //
    try {
      if (data?.images?.length > 0) {
        const deleteRes = await axios.post(
          `${BASE_URL}/api/image/image-delete`,
          {
            oldImage: userData.images,
          }
        );

        if (deleteRes?.data) {
          const formData = new FormData();
          formData.append("file", image);
          formData.append("folderName", "users");
          const uploadRes = await axios.post(
            `${BASE_URL}/api/image/users/upload`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          isFile = uploadRes?.data?.data;
          // const img = uploadRes?.data?.data;
          // isFile = `${imageUrl}/users/${img}`;
          setPreview("");
        }
      } else if (preview) {
        const formData = new FormData();
        formData.append("file", image);
        formData.append("folderName", "users");
        const uploadRes = await axios.post(
          `${BASE_URL}/api/image/users/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        isFile = uploadRes?.data?.data;
        // const img = uploadRes?.data?.data;
        // isFile = `${imageUrl}/users/${img}`;
        // isFile = uploadRes?.data?.data;
        console.log("🚀 ~ onSubmit ~ isFile:", isFile);
        // setPreview("");
      }

      const additionalData = {
        blood_group: data?.blood_group,
        nid: data?.nid,
        e_tin: data?.e_tin,
        date_of_birth: moment(birthDate).format("YYYY-MM-DD"),
      };

      const result = await updateUser({
        variables: {
          id: Number(userID),
          ip: data?.ip,
          linkedin: data?.linkedin,
          name: data?.name,
          phone: data?.mobile,
          district: Number(data?.district?.value),
          division: Number(data?.division?.value),
          upazilla: Number(data?.upazilla?.value),
          union: Number(data?.union?.value),
          images: isFile ?? image,
          username: data?.username,
          // password: data?.password ? data?.password : userData?.password,
          password: data?.password || null,
          email: data?.email,
        },
      });

      await updateUserAdditionalInfo({
        variables: { ...additionalData, user_id: Number(userID) },
      });
    } catch (error) {
      console.log("🚀 ~ onSubmit ~ error:", error);
    } finally {
      setIsLoading(false);
    }

    history.push("/profile/info");
    // location.reload();
  };

  // const handleChange = async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData();
  //   const files = [...e.target.files];
  //   setPreview(files[0]);
  //   formData.append("images", files[0]);

  //   if (farmer?.image) {
  //     let res = await axios.post(
  //       `${BASE_URL}/api/image/delete`,
  //       { oldImage: farmer?.image },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (res?.data) {
  //       const file = await axios.post(
  //         `${BASE_URL}/api/image/users/upload`,
  //         formData,
  //         {
  //           headers: {
  //             "content-type": "multipart/form-data",
  //           },
  //         }
  //       );
  //       setImage(file?.data?.data);
  //     }
  //   } else {
  //     const file = await axios.post(
  //       `${BASE_URL}/api/image/users/upload`,
  //       formData,
  //       {
  //         headers: {
  //           "content-type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     setImage(file?.data?.data);
  //   }

  // };
  const handleChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };
  const setAndClearFields = (setValue, mainField, mainValue, fieldsToClear) => {
    setValue(mainField, mainValue);

    fieldsToClear.forEach((field) => setValue(field, ""));
  };
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <form
            className={`form ${isHorizontal && "form--horizontal"}`}
            style={{ width: "100%" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Col md={8} className="mx-auto">
              <div className="form__form-group">
                <div className="input__container">
                  {preview ? (
                    <img
                      src={preview}
                      className="image-box"
                      style={{ width: "100px" }}
                      alt=""
                    />
                  ) : image ? (
                    <img
                      src={`${imageUrl}/users/${image}`}
                      style={{ width: "100px" }}
                      className="image-box"
                      alt=""
                    />
                  ) : (
                    <img
                      src={images}
                      style={{ width: "100px" }}
                      className="image-box"
                      alt=""
                    />
                  )}
                  <input
                    name="images"
                    accept=" .jpg, .jpeg, .png"
                    id="images"
                    className="input--box"
                    type="file"
                    {...register("images")}
                    onChange={handleChange}
                  />
                </div>
                <div
                  style={{
                    width: "200px",
                    margin: "10px  auto 0 auto",
                  }}
                >
                  {errors?.images && (
                    <span style={{ color: "red" }}>image is required</span>
                  )}
                </div>
              </div>

              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Full Name</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="name"
                        control={control}
                        component="input"
                        errors={errors}
                        rules={{ required: "This is required field" }}
                        defaultValue={userData?.name}
                        isAboveError={isAboveError}
                        placeholder="Name"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Username</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="username"
                        control={control}
                        component="input"
                        errors={errors}
                        rules={{ required: "This is required field" }}
                        defaultValue={userData?.username}
                        disabled
                        isAboveError={isAboveError}
                        placeholder="Username"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      Mobile Number
                    </span>
                    <div className="form__form-group-field">
                      <FormField
                        name="mobile"
                        control={control}
                        // component="input"
                        component={renderMaskedField}
                        mask={[
                          "(",
                          "+",
                          "8",
                          "8",
                          ")",
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        errors={errors}
                        rules={{ required: "This is required field" }}
                        defaultValue={userData?.phone}
                        isAboveError={isAboveError}
                        placeholder="(+88) __ __ _"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Email</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="email"
                        control={control}
                        component="input"
                        errors={errors}
                        rules={{ required: "This is required field" }}
                        defaultValue={userData?.email}
                        isAboveError={isAboveError}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      linkdin Profile
                    </span>
                    <div className="form__form-group-field">
                      <FormField
                        name="linkedin"
                        control={control}
                        component="input"
                        errors={errors}
                        // rules={{ required: "This is required field" }}
                        defaultValue={userData?.linkedin}
                        isAboveError={isAboveError}
                        placeholder="Your Linkedin Profile"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      IP Phone Number
                    </span>
                    <div className="form__form-group-field">
                      <FormField
                        name="ip"
                        control={control}
                        component="input"
                        errors={errors}
                        // rules={{ required: "This is required field" }}
                        defaultValue={userData?.ip}
                        isAboveError={isAboveError}
                        placeholder="Your IP"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              {/* personal information */}
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <label className="form__form-group-label">NID</label>
                    <div className="form__form-group-field">
                      <FormField
                        name="nid"
                        component="input"
                        errors={errors}
                        control={control}
                        defaultValue={userData?.additionalInfo?.nid}
                        // defaultValue={
                        //   data?.getUserByUserid?.additionalInfo?.nid
                        // }
                        rules={{
                          maxLength: {
                            value: maxDigits,
                            message: `Max ${maxDigits} digits`,
                          },
                          pattern: {
                            value: /^[0-9]*$/, // allow empty or only digits
                            message: "Only numbers are allowed",
                          },
                        }}
                        type="text"
                        inputMode="numeric"
                        placeholder="Enter NID"
                        isAboveError={isAboveError}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, maxDigits);
                        }}
                        aria-invalid={Boolean(errors?.nid) || undefined}
                      />
                    </div>

                    {/* Real-time helper/error text */}
                    <div className="form__form-group-hint">
                      <small
                        className={errors?.nid ? "text-danger" : "text-muted"}
                      >
                        {errors?.nid?.message
                          ? errors.nid.message
                          : `${nidValue.length}/${maxDigits} digits`}
                      </small>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form__form-group">
                    <label className="form__form-group-label">E-TIN</label>
                    <div className="form__form-group-field">
                      <FormField
                        name="e_tin"
                        component="input"
                        errors={errors}
                        control={control}
                        defaultValue={userData?.additionalInfo?.e_tin}
                        rules={{
                          maxLength: {
                            value: maxDigits,
                            message: `Max ${maxDigits} digits`,
                          },
                          pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed",
                          },
                        }}
                        type="text"
                        inputMode="numeric"
                        placeholder="Enter E_TIN"
                        isAboveError={isAboveError}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, maxDigits);
                        }}
                        aria-invalid={Boolean(errors?.e_tin) || undefined}
                      />
                    </div>

                    <div className="form__form-group-hint">
                      <small
                        className={errors?.e_tin ? "text-danger" : "text-muted"}
                      >
                        {errors?.e_tin?.message
                          ? errors.e_tin.message
                          : `${eTinValue.length}/${maxDigits} digits`}
                      </small>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Blood Group</span>
                    <div className="form__form-group-field">
                      <Controller
                        name="blood_group"
                        errors={errors}
                        control={control}
                        defaultValue={userData?.additionalInfo?.blood_group}
                        render={({ field }) => (
                          <SelectField
                            {...field}
                            options={bloodGroupOption}
                            placeholder="Select Your Blood Group"
                            value={bloodGroupOption.find(
                              (option) => option.value === field.value
                            )}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption.value);
                            }}
                          />
                        )}
                      />
                    </div>
                    {errors.blood_group && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "0.875em",
                          marginTop: "0.25em",
                        }}
                      >
                        {errors?.blood_group?.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form__form-group">
                    <label className="form__form-group-label">
                      Date of Birth
                    </label>
                    <div className="form__form-group-field">
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={birthDate}
                        placeholderText="dd/mm/yyyy"
                        onChange={handleBirtDateChange}
                        showMonthDropdown
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={100}
                      />
                    </div>
                  </div>
                </Col>
                {/* <Col md={3}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      IP Phone Number
                    </span>
                    <div className="form__form-group-field">
                      <FormField
                        name="ip"
                        control={control}
                        component="input"
                        errors={errors}
                        // rules={{ required: "This is required field" }}
                        defaultValue={userData?.ip}
                        isAboveError={isAboveError}
                        placeholder="Your IP"
                      />
                    </div>
                  </div>
                </Col> */}
              </Row>
              {/* personal information end*/}
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Division</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="division"
                        control={control}
                        component={SelectField}
                        errors={errors}
                        options={division?.map((data) => ({
                          value: data?.id,
                          label: data?.name,
                        }))}
                        onChange={(e) => {
                          setAndClearFields(setValue, "division", e, [
                            "district",
                            "upazilla",
                            "union",
                          ]);
                        }}
                        rules={{ required: "This is required field" }}
                        defaultValue={{
                          value: defaultDivision?.id
                            ? defaultDivision?.id
                            : getDivision?.id,
                          label: defaultDivision?.name
                            ? defaultDivision?.name
                            : getDivision?.name,
                        }}
                        // value="dhjs"
                        isAboveError={isAboveError}
                        placeholder="Division"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">District</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="district"
                        control={control}
                        component={SelectField}
                        errors={errors}
                        options={district?.map((data) => ({
                          value: data?.id,
                          label: data?.name,
                        }))}
                        onChange={(e) => {
                          setAndClearFields(setValue, "district", e, [
                            "upazilla",
                            "union",
                          ]);
                        }}
                        rules={{ required: "This is required field" }}
                        defaultValue={{
                          value: defaultDistrict?.id
                            ? defaultDistrict?.id
                            : getDistrict?.id,
                          label: defaultDistrict?.name
                            ? defaultDistrict?.name
                            : getDistrict?.name,
                        }}
                        isAboveError={isAboveError}
                        placeholder="District"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Upazilla</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="upazilla"
                        control={control}
                        component={SelectField}
                        errors={errors}
                        options={upazilla?.map((data) => ({
                          value: data?.id,
                          label: data?.name,
                        }))}
                        onChange={(e) => {
                          setAndClearFields(setValue, "upazilla", e, ["union"]);
                        }}
                        rules={{ required: "This is required field" }}
                        defaultValue={{
                          value: defaultUpazilla?.id
                            ? defaultUpazilla?.id
                            : getUpazilla?.id,
                          label: defaultUpazilla?.name
                            ? defaultUpazilla?.name
                            : getUpazilla?.name,
                        }}
                        isAboveError={isAboveError}
                        placeholder="Upazilla"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Union</span>
                    <div className="form__form-group-field">
                      <FormField
                        name="union"
                        control={control}
                        component={SelectField}
                        errors={errors}
                        options={union?.map((data) => ({
                          value: data?.id,
                          label: data?.name,
                        }))}
                        rules={{ required: "This is required field" }}
                        defaultValue={{
                          value: defaultUnion?.id
                            ? defaultUnion?.id
                            : getUnion?.id,
                          label: defaultUnion?.name
                            ? defaultUnion?.name
                            : getUnion?.name,
                        }}
                        isAboveError={isAboveError}
                        placeholder="union"
                      />
                    </div>
                  </div>
                </Col>

                <Col md={12}>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <ButtonToolbar className="form__button-toolbar">
                      <Button color="primary" type="submit">
                        {userID ? "Update" : "Create"}
                      </Button>
                      <Button
                        type="button"
                        onClick={() => {
                          history.push(`/profile/info`);
                        }}
                      >
                        Cancel
                      </Button>
                    </ButtonToolbar>
                  </div>
                </Col>
              </Row>
            </Col>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AgentProfileUpdate;
